import type {RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {FC} from 'react'
import {memo} from 'react'

interface HeadingSectionProps {
  heading: RichTextField
}

export const HeadingSection: FC<HeadingSectionProps> = memo(({heading}) => {
  if (!isFilled.richText(heading)) {
    return null
  }

  return (
    <div className="text-center">
      <PrismicRichText
        field={heading}
        components={{
          heading2: ({children}) => (
            <h2 className="text-[28px] font-medium leading-[32px] tracking-[-0.28px] md:text-[42px] md:leading-[48px] md:tracking-[-0.21px]">
              {children}
            </h2>
          ),
          strong: ({children}) => <strong className="font-medium opacity-60">{children}</strong>,
        }}
      />
    </div>
  )
})

HeadingSection.displayName = 'HeadingSection'
